import Vue from 'vue'

var socmed_line_color = []
socmed_line_color['twitter'] = '#1da1f2'
socmed_line_color['facebook'] = '#4267b2'
socmed_line_color['instagram'] = '#e1306c'
socmed_line_color['youtube'] = '#dc3545'
socmed_line_color['news'] = '#28a745'
socmed_line_color['forum'] = '#6c757d'
socmed_line_color['blog'] = '#ffc107'
socmed_line_color['linkedin'] = '#006192'
socmed_line_color['media_tv'] = '#e83e8c'
socmed_line_color['media_cetak'] = '#6c757d'
socmed_line_color['mention'] = '#6f42c1'
socmed_line_color['engagement'] = '#17a2b8'
socmed_line_color['reach'] = '#fd7e14'

var icon = []
icon['media_cetak'] = 'bi bi-newspaper'
icon['media_tv'] = 'bi bi-tv'
icon['news'] = 'bi bi-newspaper'
icon['online_news'] = 'bi bi-globe-americas'
icon['facebook'] = 'bi bi-facebook'
icon['twitter'] = 'bi bi-twitter'
icon['instagram'] = 'bi bi-instagram'
icon['tiktok'] = 'bi bi-tiktok'
icon['youtube'] = 'bi bi-youtube'
icon['linkedin'] = 'bi bi-linkedin'
icon['blog'] = 'bi bi-rss'
icon['forum'] = 'bi bi-chat-dots-fill'

var ner_type_icon = []
ner_type_icon['PER'] = 'fa fa-user'
ner_type_icon['NOR'] = 'fa fa-sitemap'
ner_type_icon['FAC'] = 'fa fa-building'
ner_type_icon['ORG'] = 'bi bi-people'
ner_type_icon['GPE'] = 'fas fa-city'
ner_type_icon['LOC'] = 'fas fa-map-marker'
ner_type_icon['PRO'] = 'fa fa-archive'
ner_type_icon['EVT'] = 'fas fa-calendar'
ner_type_icon['WOA'] = 'fas fa-book'
ner_type_icon['LAW'] = 'fas fa-balance-scale'
ner_type_icon['LNG'] = 'fas fa-flag'
ner_type_icon['DTE'] = 'fas fa-calendar'
ner_type_icon['TME'] = 'fas fa-calendar'
ner_type_icon['PCT'] = 'fas fa-percent'
ner_type_icon['MON'] = 'fas fa-dollar'
ner_type_icon['QUA'] = 'fas fa-globe'
ner_type_icon['ORD'] = 'fas fa-globe'
ner_type_icon['CRD'] = 'fas fa-globe'
ner_type_icon['NUM'] = 'fas fa-sort-numeric-up'
ner_type_icon['MEA'] = 'fa fa-tachometer'

var bg_color = []
bg_color['PER'] = '#008FD7'
bg_color['ORG'] = '#FDD100'
bg_color['LOC'] = '#009B4C'
bg_color['FAC'] = '#E40082'
bg_color['PRO'] = '#E62129'
bg_color['EVT'] = '#A72185'
bg_color['TME'] = '#62C3D0'
bg_color['DTE'] = '#ACCE22'
bg_color['MEA'] = '#C37733'

Vue.prototype.$channel_color = socmed_line_color
Vue.prototype.$icon = icon
Vue.prototype.$ner_icon = ner_type_icon
Vue.prototype.$bg_color = bg_color